import { inject, InjectionKey, provide } from 'vue'

export type NoActionCategoryPayload = {
    noActionCategory: {
        comment: string
    }
}

export type NoActionCategoryActions = {
    openModal: (payload?: NoActionCategoryPayload) => void
}

const NoActionCategoryInjectionKey: InjectionKey<NoActionCategoryActions> = Symbol(
    'NoActionCategoryModal',
)

export const useNoActionCategoryModal = () => {
    return inject(NoActionCategoryInjectionKey)
}

export const provideNoActionCategoryModal = (actions: NoActionCategoryActions) =>
    provide(NoActionCategoryInjectionKey, actions)
